import { Route, Routes } from 'react-router-dom';
import { Landing } from './Landing';
import { DevApp } from '../dev/DevApp';
import { PanelEntry } from './PanelEntry';

export function ApexApp() {
  return (
    <Routes>
      <Route path="/dev/*" element={<DevApp />} />
      <Route path="/painel" element={<PanelEntry />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
